/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  class DialogManager {
    constructor() {
      this.lastTrigger = null;

      document.addEventListener('click', (e) => {
        const anchor = e.target.closest('a.dialog-cta');
        if (!anchor) return;

        e.preventDefault();

        const dialogId = anchor.dataset.dialog;
        if (!dialogId) return;

        const dialog = document.getElementById(dialogId);
        if (!(dialog instanceof HTMLDialogElement)) return;

        this.lastTrigger = anchor;
        this.registerDialog(dialog);
        this.open(dialog);
      });

      document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-close-dialog]');
        if (!btn) return;

        const dialog = btn.closest('dialog');
        if (dialog instanceof HTMLDialogElement && dialog.open) {
          dialog.close();
        }
      });

    }

    open(dialog) {
      if (!dialog.open) dialog.showModal();
    }

    registerDialog(dialog) {
      if (dialog._dmRegistered) return;

      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) dialog.close();
      });

      const closeBtn = dialog.querySelector('.close-btn');
      if (closeBtn) {
        closeBtn.setAttribute('data-close-dialog', 'true');
      }

      dialog.addEventListener('close', () => {
        if (this.lastTrigger && typeof this.lastTrigger.focus === 'function') {
          this.lastTrigger.focus();
        }
      });

      dialog._dmRegistered = true;
    }
  }
  document.addEventListener('DOMContentLoaded', () => new DialogManager());

  /**
   * VideoBlockPlayer
   * - Scans .video-block__media
   * - Requires a <video> inside. If there is no overlay, creates one.
   * - Uses the <video> poster or root data-thumb as the thumbnail.
   *
   * Opciones por data-attributes en .video-block__media:
   *   data-vb-reveal-on-pause="true|false"       (default false)
   *   data-vb-controls-on-start="true|false"     (default false)
   *   data-vb-prefer-unmuted-on-play="true|false"(default true)
   *   data-thumb="URL"                           (opcional; si no, usa poster)
   */
  (function () {
    class VideoBlockPlayer {
      static #inited = new WeakSet();

      static init(selector = '.video-block__media', opts = {}) {
        document.querySelectorAll(selector).forEach((root) => {
          if (!VideoBlockPlayer.#inited.has(root)) {
            const inst = new VideoBlockPlayer(root, opts);
            if (inst.ready) VideoBlockPlayer.#inited.add(root);
          }
        });
      }

      constructor(root, opts = {}) {
        this.root = root;
        this.video = root.querySelector('video');
        this.ready = !!this.video;
        if (!this.ready) return;

        const data = root.dataset || {};
        this.opts = {
          revealOnPause: data.vbRevealOnPause === 'true' || false,
          controlsOnStart: data.vbControlsOnStart === 'true' || false,
          preferUnmutedOnPlay: data.vbPreferUnmutedOnPlay !== 'false', // default true
          ...opts
        };

        if (!this.opts.controlsOnStart) this.video.controls = false;

        this.overlay = root.querySelector('.video-block__overlay-play') || this._buildOverlay();

        this._bind();
      }

      _bind() {
        if (this.overlay) {
          this.overlay.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.play();
          });
        }
        this.video.addEventListener('play', () => this._hideOverlay());
        this.video.addEventListener('ended', () => this._showOverlay(true));
        if (this.opts.revealOnPause) {
          this.video.addEventListener('pause', () => this._showOverlay(false));
        }
      }

      async play() {
        this.video.controls = true;
        if (this.opts.preferUnmutedOnPlay) this.video.muted = false;        
          await this.video.play();  
          this._hideOverlay();  
      }

      _hideOverlay() {
        if (this.overlay) this.overlay.classList.add('is-hidden');
      }

      _showOverlay(resetToStart) {
        if (resetToStart === true) {
          try { this.video.currentTime = 0; } catch(e){}
        }
        if (this.overlay) this.overlay.classList.remove('is-hidden');
      }

      _buildOverlay() {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'video-block__overlay-play';
        btn.setAttribute('aria-label', 'Play video');

        const thumbSrc = this.root.getAttribute('data-thumb') || this.video.getAttribute('poster') || '';
        if (thumbSrc) {
          const img = document.createElement('img');
          img.className = 'video-block__overlay-thumb';
          img.src = thumbSrc;
          img.alt = (this.root.getAttribute('data-title') || this.video.getAttribute('aria-label') || 'Video');
          btn.appendChild(img);
        }

        const scrim = document.createElement('span');
        scrim.className = 'video-block__overlay-scrim';
        scrim.setAttribute('aria-hidden', 'true');

        const icon = document.createElement('span');
        icon.className = 'video-block__overlay-icon';
        icon.setAttribute('aria-hidden', 'true');

        btn.appendChild(scrim);
        btn.appendChild(icon);

        this.root.appendChild(btn);
        return btn;
      }
    }

    window.VideoBlockPlayer = VideoBlockPlayer;

    VideoBlockPlayer.init();

    document.addEventListener('shopify:section:load', () => VideoBlockPlayer.init());
    document.addEventListener('shopify:block:select', () => VideoBlockPlayer.init());
  })();






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
